import React, { useEffect, useState } from "react";
import { infoBubbleProps } from "./types";
import {
  InfoBubbleContainer,
  InfoBubbleDescription,
  InfoBubbleTitle,
} from "./styles";
import { Typography } from "Components/atoms/Typography";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

const InfoBubble: React.FC<infoBubbleProps> = ({ title, description }) => {
  const [isMobile, setMobile] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setMobile(breakpoint !== "xxl");
  }, [breakpoint]);

  return (
    <InfoBubbleContainer>
      <InfoBubbleTitle>
        <Typography variant={isMobile ? "h3" : "body"} weight={"semiBold"}>
          {title}
        </Typography>
      </InfoBubbleTitle>
      <InfoBubbleDescription>
        <Typography variant={isMobile ? "body" : "caption"} align={"justify"}>
          {description}
        </Typography>
      </InfoBubbleDescription>
    </InfoBubbleContainer>
  );
};

export default InfoBubble;
